<template>

	<div class="g-block-body-index-side g-block-body-padding" :class="{

		'g-block-body-index-side--edit': editable,

		'is-active': editable && active,

		'g-block-body-index-side--h5': h5,

		'g-block-body-padding--h5': h5,

	}" @click="onWrapClick">

		<div class="g-block-body-index-side__index-row">

			<RichTextEditable
				v-if="editable"
				class="g-block-body-index-side__index"
				fit-content
				:style="{ color: indexColor }"
				:model-value="data.index"
				placeholder="01"
				@update:model-value="onIndexUpdate"
				@focus="onWrapClick"
			/>

			<span
				v-else
				class="g-block-body-index-side__index"
				:style="{ color: indexColor }"
				aria-hidden="true"
			>{{ displayIndex }}</span>

		</div>

		<div class="g-block-body-index-side__content-box" :style="contentBoxStyle">

			<RichTextEditable v-if="editable" class="g-block-body-index-side__text" :style="{ color: themeColor }"
				:model-value="data.content" placeholder="请输入正文" @update:model-value="onContentUpdate"
				@focus="onWrapClick" />

			<div v-else class="g-block-body-index-side__text" :style="{ color: themeColor }"
				v-html="data.content || ''"></div>

		</div>

	</div>

</template>



<script>

import RichTextEditable from '../../../components/RichTextEditable.vue';

import { getTitleThemeColor } from '../../../templates.js';

import { hexToRgba, lightenHexColor } from '../../../utils/richText.js';

import { bodyMixin } from '../shared/bodyMixin.js';



export default {

	name: 'GBlockBodyIndexSide',

	components: { RichTextEditable },

	mixins: [bodyMixin],

	computed: {

		themeColor() {

			return getTitleThemeColor(this.data);

		},

		displayIndex() {

			const index = this.data?.index;

			if (index === undefined || index === null || index === '') return '01';

			return String(index);

		},

		indexColor() {

			return hexToRgba(this.themeColor, 0.38);

		},

		contentBoxStyle() {

			return {

				background: lightenHexColor(this.themeColor, 0.93),

				borderRightColor: this.themeColor,

				borderBottomColor: this.themeColor,

			};

	},

	},

	methods: {

		onIndexUpdate(index) {

			this.$emit('update', { index });

		},

	},

};

</script>



<style scoped lang="less">
@import '../shared/bodyEditShell.less';



.g-block-body-index-side {

	.body-block-edit-shell();

}



.g-block-body-index-side__index-row {

	line-height: 1;

	margin-bottom: 8px;

}



.g-block-body-index-side__index {

	display: block;

	font-size: 24px;

	font-weight: 700;

	line-height: 1;

	:deep(.g-rich-text-editable__content) {

		min-height: unset;

		padding: 0;

		font-size: inherit;

		line-height: inherit;

		color: inherit;

		font-weight: inherit;

	}

}



.g-block-body-index-side__content-box {

	border-right: 1px solid;

	border-bottom: 1px solid;

	padding: 14px 16px 16px 12px;

	box-sizing: border-box;

}



.g-block-body-index-side__text {

	.body-text-base();



	:deep(.g-rich-text-editable__content) {

		color: inherit;

	}

}



.g-block-body-index-side--h5 {

	.g-block-body-index-side__index-row {

		margin-bottom: 0.16rem;

	}

	.g-block-body-index-side__index {

		font-size: 0.48rem;

	}

	.g-block-body-index-side__content-box {

		border-right-width: 0.02rem;

		border-bottom-width: 0.02rem;

		padding: 0.28rem 0.32rem 0.32rem 0.24rem;

	}

	.body-text-base--h5(~'.g-block-body-index-side__text');

}
</style>
